var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception-btn-box"},[_c('el-button',{on:{"click":function($event){return _vm.$emit('export')}}},[_vm._v("导出 Excel")]),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.$emit('create')}}},[_vm._v("＋ 新增异常")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }